import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing, colors, flags }: Theme) => createStyles({
  root: {
    borderImage: flags.boxStyle === 'full' ? 'none' : colors.pageElements.profileCard.stroke,
    borderImageSlice: 1,
    borderWidth: flags.boxStyle === 'full' ? 0 : '2px',
    borderStyle: 'solid',
    padding: spacing(4),
    paddingBottom: spacing(2),
    background: colors.pageElements.profileCard.background,
    borderRadius: flags.boxStyle === 'full' ? spacing(2) : 0,
  },
  title: {
    margin: `${spacing(5)}px 0`,
  },
  name: {
    marginBottom: spacing(3),
    color: colors.pageElements.profileCard.username,
    textTransform: 'uppercase',
  },
  itemContainer: {
    minWidth: spacing(40),
    flexGrow: 1,
    flexBasis: 0,
    marginRight: spacing(4),
    marginBottom: spacing(2),
  },
});

export default styles;
